import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import sellerFormValidation from '../../validations/SellerFormValidation'
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";


function SellerRegisterForm() {

    const initialValues = {
        'first_name': '',
        'last_name': '',
        'email': '',
        'mob_number': '',
        'location_city': '',
    }
    const [reqPayload, setReqPayload] = React.useState(initialValues);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onSubmit = values => {
        // console.log('---onSubmit--values:', values);
        submitEmpLogin(values);
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        // validate,
        validationSchema: sellerFormValidation.sellerRegisterSchema,
        validateOnChange: false
    })

    // console.log('---formik--values:', formik.values);
    // console.log('---formik--errors:', formik.errors);

    const successResponse = (response) => {
        // console.log('---successResponse--response:', response);
        dispatch(setSnackbar({
            status: 'success',
            message: response.data.message
        }))
        navigate(`/seller/request-otp-to-login?mob_number=${response.data.data.dataset.mob_number}`)
    }

    const errorResponse = (error) => {
        formik.setErrors({ ...error.response.data.errors })
        // console.log('---errorResponse--formik--errors---221:', formik.errors);
    }

    const submitEmpLogin = async (data, query = {}) => {
        try {
            const response = await callApi.requestPOST(`/sellers-bids/seller/register`, data)
            // console.log('---submitEmpLogin---response:', response);
            successResponse(response)
        }
        catch (error) {
            // console.log('---submitEmpLogin---error:', error);
            errorResponse(error)
        }
    }


    return (
        <div>
            <Grid >

                <Box component="form" className="sm:tw-w-6/12" onSubmit={formik.handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={6}>
                            <TextField id="outlined-basic" className="tw-w-full" label="First Name" type="text" name="first_name" variant="outlined" onChange={formik.handleChange} value={formik.values.first_name} error={formik.errors.first_name ? true : false} helperText={formik.errors.first_name} required />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField id="outlined-basic" className="tw-w-full" label="Last Name" type="text" name="last_name" variant="outlined" onChange={formik.handleChange} value={formik.values.last_name} error={formik.errors.last_name ? true : false} helperText={formik.errors.last_name} required />
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TextField id="outlined-basic" className="tw-w-full" label="Email" type="email" name="email" variant="outlined" onChange={formik.handleChange} value={formik.values.email} error={formik.errors.email ? true : false} helperText={formik.errors.email} />
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TextField id="outlined-basic" className="tw-w-full" label="Mobile Number" type="number" name="mob_number" variant="outlined" onChange={formik.handleChange} value={formik.values.mob_number} error={formik.errors.mob_number ? true : false} helperText={formik.errors.mob_number} required />
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TextField id="outlined-basic" className="tw-w-full" label="Location City" type="text" name="location_city" variant="outlined" onChange={formik.handleChange} value={formik.values.location_city} error={formik.errors.location_city ? true : false} helperText={formik.errors.location_city} />
                        </Grid>
                    </Grid>

                    <Grid container spacing={5}>
                        <Grid item xs={12} sm={12} className="tw-mt-10">
                            <Button type="submit" variant="contained">Register</Button>
                        </Grid>
                    </Grid>
                </Box>

            </Grid>

            <Snackbar />
        </div>
    );

}


export { SellerRegisterForm };
